import React from 'react';
import { StickyTopBar } from '../components/StickyTopBar';
import { HeroSection } from '../components/HeroSection';
import { LeadCopy } from '../components/LeadCopy';
import { ChecklistSection } from '../components/ChecklistSection';
import { TriadaSection } from '../components/TriadaSection';
import { TimelineSection } from '../components/TimelineSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { PricingSection } from '../components/PricingSection';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
export function SalesPage() {
  return <div className="min-h-screen bg-cream-50 font-sans text-warm-800 selection:bg-sage-200 selection:text-sage-900" data-id="element-205">
      <StickyTopBar data-id="element-206" />

      <main data-id="element-207">
        <HeroSection data-id="element-208" />
        <LeadCopy data-id="element-209" />
        <ChecklistSection data-id="element-210" />
        <TriadaSection data-id="element-211" />
        <TimelineSection data-id="element-212" />
        <TestimonialsSection data-id="element-213" />
        <PricingSection data-id="element-214" />
        <FinalCTA data-id="element-215" />
      </main>

      <Footer data-id="element-216" />
    </div>;
}